export default __webpack_public_path__ + "static/media/quality.21b31cce.png";